import { createSelector } from '@reduxjs/toolkit';

import { isHearingToDeafSelector } from 'features/call/call-base/store/selectors';
import {
  activePrimaryHearingSelector,
  isPrimaryHearingConnectedSelector,
} from 'features/call/call-hearing/store';
import { VoiceSessionStatus } from 'features/voice-session/enums';
import { voiceSessionStatusSelector } from 'features/voice-session/store';

export const isHearingToDeafCallerLoadingSelector = createSelector(
  voiceSessionStatusSelector,
  activePrimaryHearingSelector,
  (voiceSessionStatus, activePrimaryHearing) =>
    voiceSessionStatus === VoiceSessionStatus.CONNECTING ||
    activePrimaryHearing.status === 'connecting'
);

/**
 * True when a hearing-to-deaf call has no connected primary hearing party.
 * `connecting` and `disconnected` both count as off the line. Secondary
 * hearing parties are ignored because the AST transfer targets the primary.
 */
export const selectIsH2DPrimaryHearingPartyDisconnected = createSelector(
  isHearingToDeafSelector,
  isPrimaryHearingConnectedSelector,
  (isHearingToDeaf, isPrimaryHearingConnected) =>
    isHearingToDeaf && !isPrimaryHearingConnected
);
